import { isNotEmpty } from "./objects";

export function slugify(str, useSeparator) {
  if (!str) {
    return str;
  }
  const separator = useSeparator || "-";
  return str
    .normalize("NFD") // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, "") // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/['’\-_]/g, "-")
    .replace(/[^a-z0-9 '’\-_]/g, "") // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, separator)
    .replace(/-{2,}/g, "-") // no more than one '-'
    .replace(/^-+|-+$/g, ""); // trim starting & ending '-'
}

export function isPrintableCharacter(char = "") {
  return isNotEmpty(char) && char.length === 1 && char.match(/\S| /);
}

export function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  ); /* eslint-disable-line no-bitwise, no-mixed-operators */
}

export function isUUID(str) {
  const regexExp =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
  return regexExp.test(str);
}

export function toUpperFirst(str) {
  str = `${str}`;
  if (!str) return str;
  return (
    str.substring(0, 1).toUpperCase() + (str.substring(1)?.toLowerCase() ?? "")
  );
}

export function toSnakeCase(str, character) {
  return (
    str &&
    str
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]+|[0-9]+/g
      )
      .map((x) => x.toLowerCase())
      .join(character || "_")
  );
}
